export default __webpack_public_path__ + "static/sunset_skates_1-2855983907218726651a4317176891da.svg";